import { useQuery } from '@tanstack/react-query';
import { queryKeys, pimsService } from '@v2/services';
import type { Pims } from '@v2/types';

interface UsePimsDetailResult {
  pims: Pims | null;
  loading: boolean;
  error: string | null;
}

export const usePimsDetail = (id: string | null): UsePimsDetailResult => {
  const query = useQuery({
    queryKey: queryKeys.pims.detail(id ?? ''),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => pimsService.getSpecificPims(id!),
    enabled: id != null && id.length > 0,
  });

  return {
    pims: query.data ?? null,
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
  };
};

export default usePimsDetail;
